export const Gutenberg = [
    {
        "DataControls": {
            "Name": "Data Controls",
            "data": [{ "Text": "Text" }, { "Number": "Number" }, { "Textarea": "Textarea" }, { "Toggle": "Switcher" }, { "GroupPopover": "Popover" }, { "Select": "Select" }, { "Select2": "Select2" }, { "RadioAdvanced": "Choose" }, { "Color": "Color" }, { "GradientColor": "GradientColor" }, { "DateTime": "DateTime" }, { "Gallery": "Gallery" }, { "Repeater": "Repeater" }]
        },
        "Multivalue Controls": {
            "Name": "Multivalue Controls",
            "data": [{ "URL": "URL" }, { "Media": "Media" }, { "IconList": "IconsControl" }]
        },
        "Unit Controls": {
            "Name": "Unit Controls",
            "data": [{ "Range": "Slider" }, { "Dimension": "Dimension" }, { "NormalHover": "NormalHover" }]
        },
        "UI Controls": {
            "Name": "UI Controls",
            "data": [{ "LableHeading": "Heading" }, { "Note": "RawHTML" }]
        },
        "Group Controls": {
            "Name": "Group Controls",
            "data": [{ "Typography": "Typography" }, { "TextShadow": "TextShadow" }, { "BoxShadow": "BoxShadow" }, { "Border": "Border" }, { "Background": "Background" }, { "FilterCss": "CssFilter" }]
        },
    },
];

export const Elementor = [
    {
        "DataControls": {
            "Name": "Data Controls",
            "data": [{ "Text": "Text" }, { "Number": "Number" }, { "Textarea": "Textarea" }, { "WYSIWYG": "WYSIWYG" }, { "Switcher": "Switcher" }, { "Popover": "Popover" }, { "Select": "Select" }, { "Select2": "Select2" }, { "Choose": "Choose" }, { "Color": "Color" }, { "DateTime": "DateTime" }, { "Gallery": "Gallery" }, { "Repeater": "Repeater" }]
        },
        "WDesignKitControls": {
            "Name": "WDsignKit Controls",
            "data": [{ "SelectTemplate": "SelectTemplate" }]
        },
        "Multivalue Controls": {
            "Name": "Multivalue Controls",
            "data": [{ "URL": "URL" }, { "Media": "Media" }, { "IconsControl": "IconsControl" }, { "HeadingTags": "HeadingTags" }]
        },
        "Unit Controls": {
            "Name": "Unit Controls",
            "data": [{ "Slider": "Slider" }, { "Dimension": "Dimension" }, { "NormalHover": "NormalHover" }]
        },
        "UI Controls": {
            "Name": "UI Controls",
            "data": [{ "Heading": "Heading" }, { "RawHTML": "RawHTML" }, { "Divider": "Divider" }]
        },
        "Group Controls": {
            "Name": "Group Controls",
            "data": [{ "Typography": "Typography" }, { "TextShadow": "TextShadow" }, { "BoxShadow": "BoxShadow" }, { "Border": "Border" }, { "Background": "Background" }, { "CssFilter": "CssFilter" }]
        }
    }
];

export const Bricks = [
    {
        "DataControls": {
            "Name": "Data Controls",
            "data": [{ "Text": "Text" }, { "Textarea": "Textarea" }, { "Color": "Color" }, { "Number": "Number" }, { "Select": "Select" }, { "Select2": "Select2" }, { "Repeater": "Repeater" }, { "DateTime": "DateTime" }, { "Gallery": "Gallery" }, { "Checkbox": "Switcher" }, { "Editor": "WYSIWYG" },]
        },
        "Multivalue Controls": {
            "Name": "Multivalue Controls",
            "data": [{ "Link": "URL" }, { "Image": "Media" }, { "Icon": "Icon" }]
        },
        "Unit Controls": {
            "Name": "Unit Controls",
            "data": [{ "Slider": "Slider" }, { "Dimension": "Dimension" }, { "Align": "Align" }]
        },
        "UI Controls": {
            "Name": "UI Controls",
            "data": [{ "Info": "Heading" }, { "Divider": "Divider" }]
        },
        "Group Controls": {
            "Name": "Group Controls",
            "data": [{ "Background": "Background" }, { "Border": "Border" }, { "Typography": "Typography" }, { "TextShadow": "TextShadow" }, { "BoxShadow": "BoxShadow" }, { "Filter": "CssFilter" }]
        }
    }
];